import cart from './modules/cart';
import order from './modules/order';
import register from './modules/register';

export default {
  cart,
  order,
  register,
}
